// extracted by mini-css-extract-plugin
module.exports = {"Arrows":"Arrows_Arrows__36Lau","hide":"Arrows_hide__2xRrt"};